import SearchIFrame from './views/SearchIFrame'
import { useApp } from './hooks/useApp'
import Layout from './layouts/Layout'
import Bookings from './views/Bookings'
import ApprovePayment from './views/bookingSteps/ApprovePayment'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useUI } from './hooks/useUI'
import { useCompanySpaces } from './queries/useCompanyQueries'
import createCustomTheme from './theme/theme'
import { adjustColor } from './theme/ajustColor'

function App() {
  const { activeTab, setActiveTab } = useApp()
  const { darkMode } = useUI()
  const { data: companyData } = useCompanySpaces()

  // Obtener el color principal de la compañía
  const primaryColor = companyData?.body?.content[0]?.color || '#0A3A7A'
  const colors = adjustColor(primaryColor, darkMode ? 'dark' : 'light')
  const theme = createCustomTheme(colors.main, darkMode ? 'dark' : 'light')

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/search" element={<SearchIFrame />} />
          <Route path="/approvePayment" element={<ApprovePayment />} />
          <Route path="/" element={<Layout children={<Bookings />} />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
